<template>
  <button
    class="p-1 rounded-lg text-sm flex flex-wrap items-start gap-3 cursor-pointer hover:bg-slate-100 w-full"
    @click="emits('open')"
  >
    <div
      class=""
      @click.stop
    >
      <transition
        name="fade"
        mode="out-in"
      >
        <UButton
          v-if="!note.read"
          icon="heroicons:envelope"
          @click="toggleRead(note)"
        />
        <UButton
          v-else
          variant="ghost"
          icon="heroicons:envelope-open"
          @click="toggleRead(note)"
        />
      </transition>
    </div>
    <div class="flex-1 flex flex-col text-left">
      <p class="text-xs pt-2">
        {{ useDateFormat(note.created, 'HH:MMa MMM D, YYYY') }}
      </p>
      <Paragraph
        :data="note.message"
        class=" flex-1 text-left mt-6 htmldescription"
      />
    </div>
  </button>
</template>

<script setup lang="ts">
  import type { MNotification } from '~/types/index'
const emits = defineEmits(['open'])
const note = defineProps<MNotification>()
const { toggleRead } = useNotification()
</script>

<style scoped>

</style>
